export const OATH_CLIENT_ID = 100;
export const HDD_CLIENT_ID = 104;

export const FILTERS_LOAD_ERROR = "Couldn't load this client's filters.";
export const FILTERS_ORDER_HINT = 'Donors see active filters in this order in the search dropdown.';
export const FILTERS_NO_SEARCH_MATCH = 'No filters match your search.';

export const OATH_NOTICE = 'HDD also shows these filters, so any change here applies to HDD too.';
export const HDD_NOTICE = "HDD uses Oath's filters. Edit them under Oath.";
export const getNoCartNotice = (clientName?: string) =>
  `${clientName ?? 'This client'} doesn't have a Shopping Cart yet. Enable it under Configurations → Shopping Cart before adding filters.`;

export const FILTER_NAME_MAX_LENGTH = 255;
export const FILTER_TYPE_OPTIONS = [
  { value: 'ISSUE', label: 'Issue' },
  { value: 'STATE', label: 'State' },
];

export const FILTER_SAVED = 'Filter saved. Changes can take up to 5 minutes to show on the site.';
export const FILTER_SAVE_ERROR = "Couldn't save this filter. Please try again.";
export const FILTER_STATUS_ERROR = "Couldn't update this filter's status. Please try again.";
export const FILTER_ORDER_SAVED =
  'Order saved. Changes can take up to 5 minutes to show on the site.';
export const FILTER_ORDER_ERROR = "Couldn't save the new order. Please try again.";
export const FILTER_ORDER_OUTDATED =
  'The filters changed since this page loaded. Reload the page and try again.';
export const REQUIRED_RECIPIENTS = 'Pick at least one recipient.';
export const FILTER_NAME_TAKEN = 'This client already has a filter with this name.';

export const RENAME_WARNING =
  'Warning: renaming this filter changes the ref code of new donations made through it.';
export const CRITERIA_NOTE = "Only recipients that match the cart's types show on the site.";
export const NOT_IN_CART = 'Not in the cart';
export const NOT_SHOWN_ON_SITE = 'Not shown on the site';
export const UNAVAILABLE_RECIPIENTS_NOTE =
  "Greyed out recipients stay in the filter, but donors won't see them.";
export const RECIPIENTS_LOAD_ERROR = "Couldn't load the recipients for this filter.";
